module.exports = __webpack_public_path__ + "static/media/G9.79ad1122.png";